module.exports = __webpack_public_path__ + "img/sc-title.e36bc6fd.png";